import common from './en-US/common';
import formatter from './en-US/formatter';

export default {
  ...common,
  ...formatter,
};
